import { render, staticRenderFns } from "./DetailValueForm.vue?vue&type=template&id=4e87e016&"
import script from "./DetailValueForm.vue?vue&type=script&lang=js&"
export * from "./DetailValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports